import { useLocalisationService } from 'providers/LocalisationProvider'

/**
 * Renders a localised sentence with a link embedded at its {LINK} placeholder,
 * e.g. "Do you agree to our {LINK}?".
 *
 * The placeholder exists so a translator can move the link within the sentence
 * rather than being held to English word order — the Spanish string puts it
 * somewhere else. The service returns the text either side; the anchor is built
 * here, so no JSX lives in `services/`.
 */
export const LocalisedLink = ({ stringKey, href, text, newTab = false }) => {
  const { prefix, suffix } = useLocalisationService().splitLinkText(stringKey)
  const newTabProps = newTab
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {}

  return (
    <span>
      {prefix}
      <a href={href} {...newTabProps}>
        {text}
      </a>
      {suffix}
    </span>
  )
}

export default LocalisedLink
